/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export default ({ color = '#FFF', ...props }: SVGAttributes<SVGElement> & { color?: string }) => (
	<svg width="24px" {...props} viewBox="0 0 24 24">
		<path
			d="M8 7h8a1 1 0 010 2H8a1 1 0 110-2zm-3 4h14a1 1 0 010 2H5a1 1 0 010-2zm5 4h4a1 1 0 010 2h-4a1 1 0 010-2z"
			fill={color}
		/>
	</svg>
);
